// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1M64_","unreadBadge":"styles_unreadBadge__10Aiu","modalContent":"styles_modalContent__1iyOm","modal":"styles_modal__2x6nb"};